// ─── recommendationLibrary.js ─────────────────────────────────────────────────
// Deterministic Higgins Recommendation content for the v3 report — a sibling to
// summaryLibrary. Produces per-tier recommendation objects (Repaint ASAP / Consider
// Painting / No Painting Required) from the view model: the RAG-tier verb + lead +
// the areas in that tier + the defect families identified there. No AI, offline, pure.
import { buildRecommendationTiers, aggregateDefectsByTier } from './reportViewModel';

export function buildRecommendationNarrative(project, vm) {
  const areas = (project && project.areas) || [];
  const tiers = vm.recommendationTiers || buildRecommendationTiers(areas);
  const defects = vm.defectsByTier || aggregateDefectsByTier(areas);
  return tiers.map((t) => ({
    rag: t.rag,
    verb: t.verb,
    lead: t.lead,
    areas: t.areas,
    identified: (defects[t.rag] || []).slice(0, 5).map((d) => d.label),
  }));
}
